<template>
  <div class="asc-derived-parameters-expression-wrapper">
    <div class="expression-input">
      <asc-accordion :value="0">
        <asc-accordion-item first>
          <template slot="header">
            <div class="configurations--header">
              <div class="configurations--header-title"></div>
              Logic String Builder
            </div>
          </template>
          <div v-if="isGuideReady" class="asc-pdf-viewer-link">
            <p>
              Reference the
              <a
                :href="pdfDocument === '' ? null : pdfDocument"
                target="_blank"
              >
                Logic Builder Guide
                <v-icon center :size="13"> {{ 'mdi-open-in-new' }} </v-icon>
              </a>
              to get started writing custom logic for your parameters. Logic
              string will accept up to 4 parameters.
            </p>
          </div>
          <div class="logic-string-builder-wrapper">
            <asc-query-builder
              label="Start building your logic here!"
              :grid-width="308"
              :allowed-characters="allowedCharacters"
              :expression-options="expressionOptions"
              :is-advanced-full-flight="isFullFlight"
              :expression-value="expressionInput"
              :parameter-list="parameterList"
              @input="handleExpressionUpdated"
            />
          </div>
        </asc-accordion-item>
      </asc-accordion>
    </div>
  </div>
</template>

<script>
import AscQueryBuilder from '@/components/atoms/AscQueryBuilder'
import AscAccordion from '@/components/atoms/AscAccordion'
import AscAccordionItem from '@/components/atoms/AscAccordionItem'

export default {
  name: 'AscDerivedParametersExpressionWrapper',

  components: {
    AscQueryBuilder,
    AscAccordion,
    AscAccordionItem,
  },

  props: {
    pdfDocument: {
      type: String,
      default: '',
    },
    allowedCharacters: {
      type: Object,
      default: () => {},
    },
    expressionOptions: {
      type: Array,
      default: () => [],
    },
    logicStringValid: {
      type: Boolean,
      default: true,
    },
    validateLoading: {
      type: Boolean,
      default: false,
    },
    expressionInput: {
      type: String,
      default: '',
    },
    parameterList: {
      type: Array,
      default: () => [],
    },
    isFullFlight: {
      type: Boolean,
      default: false,
    },
  },

  data: function () {
    return {
      doReset: true,
      updatedEditorContent: this.expressionInput,
      logicText: '',
      cursorPosition: 0,
    }
  },

  computed: {
    isEditable() {
      return true
    },
    isGuideReady() {
      if (this.pdfDocument === '') return false
      else return true
    },
    getValidateButtonText() {
      if (!this.logicStringValid) {
        return 'Validate'
      } else {
        return ''
      }
    },
    getValidateButtonIcon() {
      if (this.logicStringValid) {
        return 'mdi-check-bold'
      } else {
        return ''
      }
    },
    getValidateButtonIconOnly() {
      return this.logicStringValid
    },
  },

  watch: {
    expressionInput: function (value) {
      this.doReset = false
      this.updatedEditorContent = value
    },
  },

  methods: {
    handleExpressionUpdated(expression) {
      this.disableSave = expression.replace(/\s/g, '') === this.emptyComment
      this.updatedEditorContent = expression
      this.$emit('handleExpressionUpdated', expression)
    },

    handleValidate() {
      if (!this.logicStringValid) {
        this.$emit('handleLogicValidate', this.updatedEditorContent)
      }
    },
  },
}
</script>

<style lang="scss">
.asc-derived-parameters-expression-wrapper {
  margin-top: 20px;

  .expression-input {
    .asc-accordion {
      z-index: 0;

      .asc-pdf-viewer-link {
        a {
          color: $accent-700 !important;
          text-decoration: none;
          outline: none !important;

          &:hover {
            text-decoration: underline;
          }
        }

        .v-icon {
          color: $accent-700 !important;
        }
      }

      .logic-string-builder-wrapper {
        display: flex;
        border-top: 1px solid $gray-500;
        padding-top: 1rem;
      }

      .logic-validation-wrapper {
        margin-top: 15px;
        border-top: 1px solid $gray-500;

        .asc-accent-button-container {
          margin-top: 15px;
          float: right;

          button {
            width: 80px;
          }
        }
      }
    }
  }
}
</style>
